import React, { FC, useContext, useEffect } from 'react';
import api from 'api';
import LeadsContext from '../../../../providers/Leads/Leads.context';
import Chat from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/pages/Chat';
import MessagingProvider from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/providers/Messaging';
import { MESSAGE_LOCATION } from 'models/Message';

import './LeadMessages.styles.scss';

const LeadMessages: FC = () => {
  const { selectedLead } = useContext(LeadsContext);
  const { sessionId } = selectedLead || {};

  useEffect(() => {
    try {
      if (selectedLead.unreadMessagesCount)
        api.messages.readAllMessages(selectedLead.sessionId);
    } catch (e) {
      return;
    }
  }, [selectedLead]);

  return (
    <div className="lead-messages">
      <MessagingProvider sessionId={sessionId}>
        <Chat messageLocation={MESSAGE_LOCATION.LEADS_PAGE} />
      </MessagingProvider>
    </div>
  );
};

export default LeadMessages;
